<template>
    <div class="social">
        <a :href="!_.isUndefined(social.telegram) ? social.telegram : ''"  target="_blank" class="telegram">
          <img width="38" src="@/assets/images/common/social/telegram.png">
        </a>
        <a :href="!_.isUndefined(social.twitter) ? social.twitter : ''"  target="_blank" class="twitter">
          <img width="38" src="@/assets/images/common/social/twitter.png">
        </a>
        <a :href="!_.isUndefined(social.instagram) ? social.instagram : ''"  target="_blank" class="instagram">
          <img width="38" src="@/assets/images/common/social/instagram.png">
        </a>
        <a :href="!_.isUndefined(social.youtube) ? social.youtube : ''"  target="_blank" class="instagram">
          <img width="38" src="@/assets/images/common/social/youtube.png">
        </a>
        <a v-if="isMobile" :href="'whatsapp://send?phone=+' + (!_.isUndefined(social.whatsapp) ? social.whatsapp : '')" class="wp">
          <img width="38" src="@/assets/images/common/social/whatsapp.png">
        </a>
        <a v-if="!isMobile" :href="'https://api.whatsapp.com/send?phone=' + (!_.isUndefined(social.whatsapp) ? social.whatsapp : '')"  target="_blank" class="wp">
          <img width="38" src="@/assets/images/common/social/whatsapp.png">
        </a>
    </div>
</template>

<script>
  export default{
    computed:{
      social(){
        return this.$store.getters.getClientContent;
      }
    }
  }
</script>

<style>
  .social a{
    padding: 3px;
  }
</style>